import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface EmptyHintProps {
  hint?: string
  fallbackKey?: string
}

/** Пустое состояние виджета: подсказка бэкенда или локализованный fallback */
export function EmptyHint({ hint, fallbackKey = 'dashboard.widget.empty' }: EmptyHintProps) {
  const { t } = useTranslation()

  return (
    <Box sx={{ py: 2, textAlign: 'center' }}>
      <Typography variant="body2" color="text.secondary">
        {hint || t(fallbackKey)}
      </Typography>
    </Box>
  )
}
